export default {
  LocationAnalysisModal: {
    title: 'Geolocation Analysis',
  },
  brand: {
    brandTitle: 'Brand',
    hotBrand: 'Hot Brands',
    allBrand: 'All Brands',
    tips: {
      max: 'Max select is {0}',
    },
    search: 'search',
    selected: 'secected',
  },
  category: {
    categoryTitle: 'Category',
    tips: {
      max: 'Max select is {0}',
    },
  },
  selected: {
    title: 'Shop Selected',
    downloadTitle: 'Benchmark Shop Selected',
  },
  selectedBrand: {
    title: 'Brand Selected',
  },
  selectedFavorite: {
    title: 'Selected Favorite',
  },
  exportFormat: {
    title: 'Select Report Format',
    tips: {
      max: 'Max select is {0}',
    },
  },
  group: {
    title: 'Export per Favorites',
    noData: 'No Data',
    tips: {
      max: 'Max select is {0}',
    },
  },
  shop: {
    title: 'Shop Search',
    continent: 'Continent',
    marked: 'Market',
    shopType: 'Shop Type',
    tips: {
      max: 'Max select is {0}',
    },
    all: 'All',
    shop: 'Shop',
    downloadTitle: 'Benchmark Shop Search',
  },
};
